import React from 'react'
import './Footer.css'

export const Footer = () => {
  return (
    <div>Footer</div>
  )
}
export default Footer;